import Cookie from 'js-cookie';

import { RUNTIME_ENVIRONMENT } from 'src/dataLayer/env';
import { reportCookieFailure } from 'src/dataLayer/remoteData/rollbar';

const BABBEL_TRACKING_UUID = 'babbeltrackinguuid';

const handleMissingCookie = (): void => {
  // do this only in production and staging
  // TODO: we can remove the following line when we define the type for reportCookieFailure
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  if (['production', 'staging'].includes(RUNTIME_ENVIRONMENT)) reportCookieFailure(BABBEL_TRACKING_UUID);
};

export const getTrackingUUID = (): string | void =>
  Cookie.get(BABBEL_TRACKING_UUID) || handleMissingCookie();
